import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Form } from 'antd';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import { DECREASE_ADJUSTMENT, INCREASE_ADJUSTMENT } from 'constants/stockMovementTypes';
import './style.css';
var formatQuantity = function (value) {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(Number(value) || 0);
};
var StockPreview = function (_a) {
    var label = _a.label;
    return (_jsx("div", { className: "smv-form__static", children: label }));
};
var AdjustmentMovementForm = function (props) {
    var _a;
    var t = props.translate, stockMovement = props.stockMovement;
    var form = Form.useFormInstance();
    var clinicService = services.clinicService, productService = services.productService, userService = services.userService;
    var _b = clinicService.useClinics(), clinics = _b.data, clinicsLoading = _b.isLoading;
    var loggedInData = userService.useLoginData().data;
    var productId = stockMovement.getProductId();
    var moveType = stockMovement.getMoveType();
    var _c = productService.useProduct(productId, productId > 0), product = _c.data, productLoading = _c.isLoading, isFetching = _c.isFetching;
    var clinic = clinicService.getClinicByCode(clinics || [], (loggedInData === null || loggedInData === void 0 ? void 0 : loggedInData.clinicCode) || '');
    var clinicStock = useMemo(function () {
        if (!product || !clinic)
            return undefined;
        return product.getStocks().find(function (stock) { var _a; return ((_a = stock.getLocation()) === null || _a === void 0 ? void 0 : _a.getId()) === clinic.getId(); });
    }, [product, clinic]);
    var clinicStockId = (clinicStock === null || clinicStock === void 0 ? void 0 : clinicStock.getId()) || 0;
    var loading = productId > 0 && !clinicStock && (productLoading || isFetching || clinicsLoading || !loggedInData || !clinics);
    useEffect(function () {
        stockMovement.setEntityId(clinicStockId);
        form.setFieldsValue({ clinicStock: clinicStockId || undefined });
    }, [clinicStockId, moveType, form, stockMovement]);
    var preview = clinicStock
        ? t('adjustmentOnHand', {
            location: ((_a = clinicStock.getLocation()) === null || _a === void 0 ? void 0 : _a.getName()) || (clinic === null || clinic === void 0 ? void 0 : clinic.getName()) || '',
            quantity: formatQuantity(clinicStock.getQuantity())
        })
        : '';
    var hint = function () {
        if (!productId)
            return t('adjustmentChooseProduct');
        if (loading)
            return t('adjustmentLoading');
        if (!clinicStock)
            return t('adjustmentMissing');
        if (moveType === INCREASE_ADJUSTMENT)
            return t('adjustmentHintIncrease');
        if (moveType === DECREASE_ADJUSTMENT)
            return t('adjustmentHintDecrease');
        return '';
    };
    return (_jsxs("div", { className: "smv-form__field", children: [_jsxs("span", { className: "smv-form__label", children: [t('adjustmentLocation'), " ", _jsx("span", { className: "smv-form__req", children: "*" })] }), _jsx(Form.Item, { name: "clinicStock", hidden: !clinicStock, rules: productId ? [{ required: true, message: t('errors.clinicStock') }] : [], children: _jsx(StockPreview, { label: preview }) }), _jsx("p", { className: "smv-form__hint".concat(productId && !loading && !clinicStock ? ' is-error' : ''), children: hint() })] }));
};
export default localeTranslator(AdjustmentMovementForm, 'stockMovementForm');
